

	import { Component, Prop } from 'vue-property-decorator';
	import { PropType } from 'vue';
	import { BaseView } from '@shared/views/BaseView';
	import { Company } from '@shared/models';

	@Component({})
	export default class CompanyBrandImage extends BaseView {

		@Prop({ type: Object as PropType<Company> })
		public model: Company;



	}

